import { z } from 'zod';
import { CoreNotifySubscriptionPreferenceTypeSchema } from '../inputTypeSchemas/CoreNotifySubscriptionPreferenceTypeSchema'

/////////////////////////////////////////
// CORE NOTIFY SUBSCRIPTION PREFERENCE SCHEMA
/////////////////////////////////////////

export const CoreNotifySubscriptionPreferenceSchema = z.object({
  type: CoreNotifySubscriptionPreferenceTypeSchema,
  subscriberContactMethodId: z.number().int(),
  subscriptionGroupId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
})

export type CoreNotifySubscriptionPreference = z.infer<typeof CoreNotifySubscriptionPreferenceSchema>

export default CoreNotifySubscriptionPreferenceSchema;
